import { talent } from "../../assets/dataSets/introContent";
import { renderIntro } from "../general/renderGrid";

function TalentIntro(){
    return(
        renderIntro(talent.title, talent.content)
    )
}

export default TalentIntro